export const API_QUICK_PAYMENT = '/quick-payment';
export const API_QUICK_PAYMENT_REPORT_TO_EMAIL = '/quick-payment/reportToEmail';
export const API_ORDER_REJECTION_REASON = '/order-rejection-reason';
export const API_REPORT_ORDERS = '/report/orders';
export const API_REPORT_SERVICE = '/report/service';
export const API_REPORT_ORDERS_FILE = '/report/orders/file';
export const API_REPORT_SERVICE_FILE = '/report/service/file';
export const API_ORDER_ACTUAL_DATES_REPORT_WITH_EMAIL = '/order-actual-date/reportToEmail';
